import React, { ReactNode } from 'react'
import { useSiteMetadata } from '../hooks/use-site-metadata'

interface SEOProps {
    title?: string
    description?: string
    path: string
    themeColor?: string
    imageUrl?: string
    children?: ReactNode
}

// Usage: https://www.gatsbyjs.com/docs/how-to/adding-common-features/adding-seo-component/#usage-in-pages

export const SEO = ({ title, description, children, path, imageUrl }: SEOProps) => {
    const { title: defaultTitle, description: defaultDescription, siteUrl } = useSiteMetadata()

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
    }

    const pageUrl = new URL(path, siteUrl)
    const ogImgUrl = imageUrl ?? `${siteUrl}/images/koherent-og.jpg`

    return (
        <>
            <title>{seo.title}</title>
            <meta name="description" property="description" content={seo.description} />
            <meta name="og:description" property="og:description" content={seo.description} />
            <meta name="og:type" property="og:type" content="website" />
            <meta name="og:title" property="og:title" content={seo.title} />
            <meta name="og:image" property="og:image" content={ogImgUrl} />
            <meta name="og:url" property="og:url" content={pageUrl.href} />

            <link rel="canonical" href={pageUrl.href}></link>

            {children}
        </>
    )
}
